import { isPlatformBrowser, PlatformLocation } from '@angular/common';
import { APP_BOOTSTRAP_LISTENER, ApplicationRef, inject, PLATFORM_ID, Provider } from '@angular/core';
import { filter, firstValueFrom, map, merge, take, timer } from 'rxjs';

import { Environment, ENVIRONMENT } from '@environment';

import { APP_GIT_VERSION, AppGitVersion } from './app-git-version';
import { INITIAL_SESSION_GUID_TOKEN, provideInitialSessionGuid } from './initial-session-guid';

export function postBootstrapVersionLogger(
  platformId: PlatformLocation,
  appRef: ApplicationRef,
  enviroment: Environment,
  appGitVersion: AppGitVersion
): () => void {
  const initialSessionGuid = inject(INITIAL_SESSION_GUID_TOKEN, { optional: true });

  const appStable$ = appRef.isStable.pipe(
    filter(Boolean),
    map(() => 'stable')
  );

  const sessionText = (sessionId: string, addBreakLine?: boolean) =>
    sessionId?.length ? `${addBreakLine ? '\n' : ''}[Session] ${sessionId}` : ``;

  return () => {
    if (isPlatformBrowser(platformId)) {
      firstValueFrom(appStable$).then(status => {
        const isStable = status === 'stable';
        if (enviroment.mode !== 'prod') {
          console.info(
            `[App Version] ${appGitVersion.branch} - ${appGitVersion.commit} \nBuilt on ${new Date(appGitVersion.timestamp)}.\nApplication is stable ${isStable}${sessionText(initialSessionGuid, true)}`
          );
        } else {
          console.info(`[App Version] ${appGitVersion.commit} ${sessionText(initialSessionGuid)}`);
        }
      });
    }
  };
}

export function providePostBootstrapVersionLogger(version: AppGitVersion): Provider {
  return [
    provideInitialSessionGuid(),
    {
      provide: APP_GIT_VERSION,
      useValue: version
    },
    {
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: postBootstrapVersionLogger,
      deps: [PLATFORM_ID, ApplicationRef, ENVIRONMENT, APP_GIT_VERSION],
      multi: true
    }
  ];
}
